/**
 * @generated SignedSource<<b6d401298e3d5e91a6bd791004d4f555>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type GameAggregator = "BJFUN" | "ENDORPHINA" | "HUB88" | "SEVEN" | "SOFT_SWISS" | "%future added value";
export type ThumbnailSliderRecommendationsQuery$variables = {};
export type ThumbnailSliderRecommendationsQuery$data = {
  readonly userRecommendations: ReadonlyArray<{
    readonly urlThumb: string | null;
    readonly aggregator: GameAggregator;
    readonly gameId: string;
    readonly category: string | null;
    readonly provider: string | null;
    readonly label: string;
    readonly customThumb: boolean;
  }>;
};
export type ThumbnailSliderRecommendationsQuery = {
  variables: ThumbnailSliderRecommendationsQuery$variables;
  response: ThumbnailSliderRecommendationsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NormalizedGame",
    "kind": "LinkedField",
    "name": "userRecommendations",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlThumb",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aggregator",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "gameId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "category",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customThumb",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ThumbnailSliderRecommendationsQuery",
    "selections": (v0/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ThumbnailSliderRecommendationsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c4075ce9407cebbbb2d13b3ddd2e14cd",
    "id": null,
    "metadata": {},
    "name": "ThumbnailSliderRecommendationsQuery",
    "operationKind": "query",
    "text": "query ThumbnailSliderRecommendationsQuery {\n  userRecommendations {\n    urlThumb\n    aggregator\n    gameId\n    category\n    provider\n    label\n    customThumb\n  }\n}\n"
  }
};
})();

(node as any).hash = "94058d782d46451d4e6b13c051f3728d";

export default node;
